<template>
    <div>
        <left-column :style="{backgroundImage:bgImg}" class="stepSummary" >
            <div class="wgCalcSummary">
                <p>{{$t('step_summary.household')}}</p>
                <div class="wgCalcSummary__table">
                    <div class="wgCalcSummary__table-col">
                        <div class="wgCalcSummary__table-cell">
                            <div class="wgCalcSummary__table-icon">
                                <svg width="11" height="11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M9.821 1.964h-.785V1.18C9.036.528 8.508 0 7.857 0H1.18C.528 0 0 .528 0 1.179v6.678c0 .651.528 1.179 1.179 1.179h.785v.785c0 .651.528 1.179 1.179 1.179H9.82C10.472 11 11 10.472 11 9.821V3.143c0-.651-.528-1.179-1.179-1.179zm.393 7.857a.393.393 0 01-.393.393H3.143a.393.393 0 01-.393-.393v-.785h5.107c.651 0 1.179-.528 1.179-1.179V2.75h.785c.217 0 .393.176.393.393V9.82z"
                                        fill="#fff"></path>
                                </svg>
                            </div>
                            <div class="wgCalcSummary__table-label">{{panels[$storage.state.summary.panels.type].title}} </div>
                        </div>

                        <div class="wgCalcSummary__table-cell">
                            <div class="wgCalcSummary__table-icon">
                                <svg width="11" height="11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#tiles_svg__clip0)" fill="#fff">
                                        <path
                                            d="M4.654 0H.424A.423.423 0 000 .423v4.23c0 .235.19.424.423.424h4.23c.235 0 .424-.19.424-.423V.424A.423.423 0 004.654 0zM10.577 0h-4.23a.423.423 0 00-.424.423v4.23c0 .235.19.424.423.424h4.231c.234 0 .423-.19.423-.423V.424A.423.423 0 0010.577 0zM4.654 5.923H.424A.423.423 0 000 6.346v4.231c0 .234.19.423.423.423h4.23c.235 0 .424-.19.424-.423v-4.23a.423.423 0 00-.423-.424zM10.577 5.923h-4.23a.423.423 0 00-.424.423v4.231c0 .234.19.423.423.423h4.231c.234 0 .423-.19.423-.423v-4.23a.423.423 0 00-.423-.424z"></path>
                                    </g>
                                    <defs>
                                        <clipPath id="tiles_svg__clip0">
                                            <path fill="#fff" d="M0 0h11v11H0z"></path>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <div class="wgCalcSummary__table-label" >{{$storage.state.summary.panels.amount}} {{$t('step_summary.solar_panels')}}</div>
                        </div>
                        <div class="wgCalcSummary__table-cell">
                            <div class="wgCalcSummary__table-icon">
                                <svg width="11" height="11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#home_svg__clip0)">
                                        <path
                                            d="M10.885 5.222l-.785-.785L5.778.115a.393.393 0 00-.555 0L.9 4.436l-.786.786a.393.393 0 00.556.556l.115-.115v4.944c0 .217.176.393.393.393h2.357V6.679c0-.217.176-.393.393-.393h3.143c.217 0 .393.176.393.393V11h2.357a.393.393 0 00.393-.393V5.663l.115.115a.393.393 0 00.555-.556z"
                                            fill="#fff"></path>
                                    </g>
                                    <defs>
                                        <clipPath id="home_svg__clip0">
                                            <path fill="#fff" d="M0 0h11v11H0z"></path>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <div class="wgCalcSummary__table-label">{{ $t('slopes.'+$storage.state.summary.roof.type) }}{{ $storage.state.summary.roof.material ? ', '+ $storage.state.summary.roof.material : ''}}</div>

                        </div>
                    </div>
                    <div class="wgCalcSummary__table-col"  v-if="wgCalc.showAddons">
                        <div class="wgCalcSummary__table-cell" v-for="product of accessories(false)" :key="'add_prod_'+product.key">

                            <div class="wgCalcSummary__table-icon">
                                <svg width="11" height="11" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="product.key == 'battery'">
                                    <g clip-path="url(#battery_svg__clip0)" fill="#fff">
                                        <path
                                            d="M8.774 6.99v.458c0 .506-.41.917-.917.917H1.26a.916.916 0 01-.916-.917V3.094c0-.507.41-.917.916-.917h6.597c.507 0 .917.41.917.917v.458h1.424c.253 0 .458.205.458.458v2.521a.458.458 0 01-.458.459H8.774z"></path>
                                        <path
                                            d="M7.857 8.708H1.26C.566 8.708 0 8.143 0 7.448V3.094c0-.696.566-1.26 1.26-1.26h6.597c.695 0 1.26.564 1.26 1.26v.114h1.077c.442 0 .802.36.802.802v2.521c0 .443-.36.802-.802.802H9.118v.115c0 .695-.566 1.26-1.26 1.26zM1.26 2.521a.574.574 0 00-.573.573v4.354c0 .316.258.573.573.573h6.597a.574.574 0 00.573-.573V6.99c0-.19.154-.344.344-.344h1.42a.115.115 0 00.114-.115v-2.52a.115.115 0 00-.114-.115h-1.42a.344.344 0 01-.344-.344v-.458a.574.574 0 00-.573-.573H1.26z"></path>
                                    </g>
                                    <defs>
                                        <clipPath id="battery_svg__clip0">
                                            <path fill="#fff" d="M0 0h11v11H0z"></path>
                                        </clipPath>
                                    </defs>
                                </svg>
                                <svg v-else-if="product.key=='charger'" width="12" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.44 2.615L1.155 9.481H6l-.44 4.442 5.286-6.865H6l.44-4.443z" fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="square"></path></svg>
                                <icon-battery v-else/>
                            </div>
                            <div class="wgCalcSummary__table-label">{{product.label }}: {{ $storage.state.summary.products.indexOf(product.key)!==-1 ? $t('step_summary.yes') : $t('step_summary.not_picked') }}</div>
                        </div>
                    </div>
                </div>
                <div class="wgCalcSummaryInvoice mt-5" v-if="wgCalc.showPrices">
                    <h2 class="wgCalcSummaryInvoice__heading" v-if="$t('step_summary.invoice')"><span>{{$t('step_summary.invoice')}}</span></h2>
                    <div class="wgCalcSummaryInvoice__table mt-5">
                        <div class="wgCalcSummaryInvoice__table_row"  v-if="hideIfZero && $storage.state.invoice.panels ">
                            {{$t('step_summary.panels')}}
                            <span class="wgCalcSummaryInvoice__table_price">{{ $storage.state.invoice.panels | formatNumber }} {{ $t('cur_sign')}}</span>
                        </div>
                        <div class="wgCalcSummaryInvoice__table_row" v-for="product of accessories(true)" :key="'acc_'+product.key" >
                            {{ product.label }}
                            <span class="wgCalcSummaryInvoice__table_price"> {{ product.price | formatNumber }} {{ $t('cur_sign')}}</span>
                        </div>
                        <div class="wgCalcSummaryInvoice__table_row" v-if="hideIfZero && $storage.state.invoice.greenDiscount " >
                            {{$t('step_summary.green_subsidy')}}
                            <span class="wgCalcSummaryInvoice__table_price"> - {{ $storage.state.invoice.greenDiscount | formatNumber }} {{ $t('cur_sign')}}</span>
                        </div>
                        <div class="wgCalcSummaryInvoice__table_row wgCalcSummaryInvoice__table_row_total">
                            {{$t('step_summary.total')}}
                            <span class="wgCalcSummaryInvoice__table_price">{{ $storage.state.invoice.total | formatNumber }} kr</span>
                        </div>
                    </div>
                    <template v-if="$t('step_summary.disclaimer')" >
                        <div class="mt-4" v-html="$t('step_summary.disclaimer')"></div>
                    </template>
                </div>


            </div>
        </left-column>
        <right-column class="align-start">
            <h2>{{$t('step_summary.heading')}}</h2>
            <p style="font-size: 0.9em;">{{$t('step_summary.subheading')}}</p>
            <div class="wgCalcForm mb-auto w-100">
                <v-form
                    ref="form"
                    v-model="formValid"
                >

                    <v-container class="mx-n2">
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="$storage.state.form.fname"
                                    :rules="rules.fname"
                                    :label="$t('step_summary.form.fname')"
                                    required
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="$storage.state.form.lname"
                                    :rules="rules.lname"
                                    :label="$t('step_summary.form.lname')"
                                    required
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="$storage.state.form.email"
                                    :rules="rules.email"
                                    :label="$t('step_summary.form.email')"
                                    required
                                    type="email"
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <vue-tel-input-vuetify
                                    v-model="$storage.state.form.phone"
                                    defaultCountry="SE"
                                    :preferred-countries="['SE','DK','NO','FI']"
                                    :label="$t('step_summary.form.phone')"
                                    :input-options="{ showDialCode: false, tabindex: 0 }"
                                    :rules="rules.phone"
                                    dense
                                ></vue-tel-input-vuetify>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="$storage.state.form.address"
                                    :rules="rules.address"
                                    :label="$t('step_summary.form.address')"
                                    required
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="$storage.state.form.zipcode"
                                    :rules="rules.zipcode"
                                    :label="$t('step_summary.form.zipcode')"
                                    required
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="$storage.state.form.city"
                                    :rules="rules.city"
                                    :label="$t('step_summary.form.city')"
                                    required
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="$storage.state.form.code"
                                    :rules="rules.code"
                                    :label="$t('step_summary.form.code')"
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-textarea
                                    v-model="$storage.state.form.message"
                                    :rules="rules.code"
                                    :label="$t('step_summary.form.message')"
                                    dense
                                    rows="1"
                                ></v-textarea>
                            </v-col>
                            <v-col cols="12" class="fs-12 pt-0" >
                                <v-checkbox
                                    v-model="$storage.state.form.confirm"
                                    :rules="rules.confirm"
                                    :label="$t('step_summary.form.accept')"
                                    required
                                    dense
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="12" class="fs-14 pt-0" v-if="wgCalc.campaign && wgCalc.campaign.text">
                                <v-checkbox
                                    v-model="$storage.state.form.campaign"
                                    required
                                    dense
                                >

                                    <template v-slot:label><span v-html="wgCalc.campaign.text"></span></template>
                                </v-checkbox>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
                <v-alert type="error" v-if="error_message">
                    {{error_message}}
                </v-alert>
            </div>
        </right-column>
    </div>
</template>
<script>
import LeftColumn from "../LeftColumn";
import RightColumn from "../RightColumn";
import steps from "./mixins/steps";
import {slopes} from "../../helpers";
import IconBattery from "@/assets/battery.svg?v-component";

const accessoriesList = window.wgCalc.accessories || {};
const panels = window.wgCalc.products || {};

//import VueTelInputVuetify from "vue-tel-input-vuetify/lib"
export const STEP_KEY = 'summary'
export default {
    name:'StepSummary',
    mixins:[steps],
    components: {
        LeftColumn,
        RightColumn,
        IconBattery
        //VueTelInputVuetify
    },
    data(){
        return {
            wgCalc:window.wgCalc,
            bgImg: `url(${require('@/assets/bg/step_summary.jpeg')})`,
            formValid: true,
            panels,
            slopes,
            rules:{
                fname:[
                    v => !!v || this.$t('step_summary.form.error.fname'),
                ],
                lname:[
                    v => !!v || this.$t('step_summary.form.error.lname'),
                ],
                email:[
                    v => !!v || this.$t('step_summary.form.error.email.required'),
                    /*eslint no-useless-escape: "off" */
                    v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$t('step_summary.form.error.email.valid'),
                ],
                phone:[
                    v => !!v || this.$t('step_summary.form.error.phone'),
                ],
                city:[
                    v => !!v || this.$t('step_summary.form.error.city'),
                ],
                address:[
                    v => !!v || this.$t('step_summary.form.error.address'),
                ],
                zipcode:[
                    v => !!v || this.$t('step_summary.form.error.zipcode'),
                ],
                code:[
                ],
                confirm:[
                    v => !!v || this.$t('step_summary.form.error.accept'),
                ]
            },
            error_message: false,
        }
    },
    computed:{
        isValid(){
            const formValid = this.formValid;
            return this.$refs.form && formValid ;
        },
        hideIfZero(){
            return undefined != window.wgCalc.hideIfZero && window.wgCalc.hideIfZero;
        }

    },
    methods:{

        applyNext(){
            this.error_message = null;
            if(!this.$refs.form.validate()){
                return false;
            }

            this.$storage.showLoading();
            fetch(window.wgCalc.baseUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                //credentials:'include',
                body: JSON.stringify({form: this.$storage.state.form, summary: this.$storage.state.summary,invoice: this.$storage.state.invoice }),
            })
                .then(response => response.json())
                .then(data => {
                    if(undefined !==data.success){
                        if(this.$storage.state.passed.indexOf(STEP_KEY)<=0){
                            this.$storage.state.passed.push(STEP_KEY);
                        }

                        if (undefined !== this.wgCalc.successCallback &&  typeof this.wgCalc.successCallback === 'function') {
                            this.wgCalc.successCallback(this.$storage.state.form);
                        }
                        this.$storage.state.currentStep = this.$storage.state.steps[this.$storage.state.steps.indexOf(this.$storage.state.currentStep)+1];
                    }else{
                        this.error_message = undefined !== data.error ? data.error : this.$t('form.form_submit_error')
                    }
                    this.$storage.hideLoading();


                })
                .catch((error) => {
                    this.$storage.hideLoading();
                    this.error_message = error;
                    console.error('Error:', error);
                });

        },
        accessories(isPrice = false){
            return accessoriesList.filter(i =>
                this.$storage.state.summary.products.indexOf(i.key)!==-1  &&  ( isPrice  ?   !(undefined != window.wgCalc.hideIfZero && window.wgCalc.hideIfZero && i.price == 0) : true )
            )
        }
    }

}
</script>
<style lang="scss">
.wgCalc{
    &Summary{
        $border-color: rgba(255, 255, 255, 0.3);
        color: #FFF;
        padding: 2rem;
        margin-top: auto;
        width: 100%;
        &__table{
            margin-bottom: 1rem;
            background-color: $border-color;
            border-radius: 10px;
            padding: 1rem 1.875rem !important;

            @media only screen and (min-width: 755px) {
                display: flex;
                flex-direction: row;
            }

            &-inner{
                display: grid;
                grid-template-columns: 1fr 1fr;
                margin-bottom: 0px;
                padding: 0px;
                place-items: center start;
                -webkit-box-align: center;
                gap: 0.25rem;
            }
            &-cell{
                display: flex;
                align-items: center;
                width: 100%;
                margin-bottom: 0.3em;
            }
            &-icon{
                margin-right: 10px;
            }
            &-label{
                font-weight: normal;
            }
            &-col{
                flex: 1 0 0%;
            }
        }
        &Invoice{
            &__heading{
                border-bottom: 3px solid $border-color;
                color: #FFF !important;
                span{
                    position: relative;
                    display: inline-block;
                    &::after{
                        display: block;
                        content:'';
                        position: absolute;
                        height: 3px;
                        width: 100%;
                        background: #FFF;
                    }
                }

            }
            &__table{
                &_row{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 5px 0;

                    &_total{
                        font-size: 1.3rem;
                        //border-top: 1px solid $border-color;
                    }
                }
            }
        }



    }
    &LeftCol{
        @media only screen and (max-width: 755px){
            &.stepSummary{
                flex-grow: 1;
                height: auto;
            }
        }
    }
    &Form{
        @media only screen and (min-width: 1024px){
            max-height: 450px;
            overflow: auto;
        }
    }
}
</style>
